import { render, staticRenderFns } from "./RowByPage.vue?vue&type=template&id=77682208&scoped=true&"
import script from "./RowByPage.vue?vue&type=script&lang=js&"
export * from "./RowByPage.vue?vue&type=script&lang=js&"
import style0 from "./RowByPage.vue?vue&type=style&index=0&id=77682208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77682208",
  null
  
)

export default component.exports